import React from 'react';
import { Box } from 'components/index';

function TabPanel(props: any) {
  const { children, value, index, ...other } = props;

  return (
    <div role='tabpanel' hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && <Box sx={{ p: 0, mt: 1, mb: 4, height: '100%' }}>{children}</Box>}
    </div>
  );
}

export default TabPanel;
